/**
 * Issue d'une confrontation du point de vue de l'utilisateur
 */
export const OUTCOMES = {
  WIN: "win",
  DRAW: "draw",
  LOSS: "loss",
};

// Victoire et défaite reprennent les émoji de la qualification en tournoi
export const OUTCOME_EMOJIS = {
  [OUTCOMES.WIN]: "🎉",
  [OUTCOMES.DRAW]: "🤝",
  [OUTCOMES.LOSS]: "😭",
};

// Libellés français des issues, pour les lecteurs d'écran
export const OUTCOME_LABELS = {
  [OUTCOMES.WIN]: "Victoire",
  [OUTCOMES.DRAW]: "Match nul",
  [OUTCOMES.LOSS]: "Défaite",
};

// Ordre d'affichage du bilan d'une ligue
export const OUTCOMES_ORDER = [OUTCOMES.WIN, OUTCOMES.DRAW, OUTCOMES.LOSS];